<template>
  <main class="build-your-deal-page" role="main">    
    <vue-loading :active.sync="isLoading" 
        :can-cancel="false"         
        :is-full-page="false"></vue-loading>
    <div class="wizard-container" v-if="!isLoading">
      <vue-good-wizard 
        ref="wizard"
        :steps="dealSteps"
        >
          <div slot="product-selector">
            <product-selector :builder="builder"></product-selector>
          </div>
          <div slot="subscriber-details">
            <subscriber-details :builder="builder" :allowAnother="allowAnother"></subscriber-details>
          </div>
      </vue-good-wizard>
    </div>
  </main>
</template>

<script>
import SimModel from '@/models/sim.model.js'
import { GoodWizard } from "vue-good-wizard";
import Selector from "./selector.vue";
import SubscriberDetails from "./subscriber-details.vue";

import EventBus from '@/components/shared/event-bus';
import store from "@/store";

import {   
  CART_UPDATE_SUBSCRIBER,
  CART_ADD_ITEM,
  CART_RESET_CURRENT_ITEM,
  CART_UPDATE_CURRENT_ITEM,
  CART_UPDATE_CURRENT_STEP
} from "@/store/actions.type";

export default {
  name: "build-your-deal",
  components: {
    "vue-good-wizard": GoodWizard,
    "product-selector": Selector,
    "subscriber-details": SubscriberDetails
  },
  data() {
    return {
      is_loading: true,
      builder: false,
      allowAnother: true,
      dealSteps: [
        {
          slot: "product-selector"
        },
        {
          slot: "subscriber-details"
        }
      ],
      currentPage: store.state.cart.current_step
    };
  },
  computed: {    
    isLoading() {
      return store.state.products.is_loading;
    }
  },
  beforeMount() {
    var self = this;    
    self.builder = self.$attrs.builder;
    self.registerListeners();      
  },
  mounted() {  
    var self = this;    
    self.builder = self.$attrs.builder;
    store.dispatch(CART_RESET_CURRENT_ITEM);  
    self.goToStep(store.state.cart.current_step);
    
    var selected_deal = self.$route.params.deal;
    if (typeof selected_deal != "undefined" && selected_deal != "" && selected_deal) {     
      self.allowAnother = false;
    }
  },
  methods: {
    setIccid(iccid) {
      var sim = new SimModel();
      sim.iccid = iccid;  
      store.dispatch(CART_UPDATE_CURRENT_ITEM, sim);
      store.dispatch(CART_UPDATE_CURRENT_STEP, 0);    
    },
    addSim(sim, step) {
      store.dispatch(CART_ADD_ITEM, sim);
      store.dispatch(CART_RESET_CURRENT_ITEM);
      store.dispatch(CART_UPDATE_CURRENT_STEP, step);
    },
    goNext() {
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, self.currentPage);
      self.$refs.wizard.goNext(true);
    },
    goBack() {
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, self.currentPage);
      self.$refs.wizard.goBack(true);
    },
    goToStep(step) {      
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, step);      
      self.$refs.wizard.goTo(step);
    },    
    registerListeners() {
      var self = this;
      EventBus.$on('next-step', function (state) {       
        self.$log.debug("THIS IS THE STATE", state); 
        if(state == true && self.goNext(true)) {          
          self.currentPage++;          
        }
      });
      EventBus.$on('checkout', function (sim) {        
        if(sim) {
          self.currentPage++;
          self.addSim(sim, self.currentPage);
          self.$router.push({name: "checkout"});
        }
      });
      EventBus.$on('add-another-sim', function (sim) {        
        if(sim) {                    
          self.addSim(sim, 0);
          self.goBack(true);
        }
      });
      EventBus.$on('back-step', function (s) {
        if(s.state && self.currentPage > 0) {
          self.currentPage--;          
          self.goBack(true);
        }
      });
      EventBus.$on('subscriber-updated', function (value) {
        self.$log.debug("Subscriber Updating");
        store.dispatch(CART_UPDATE_SUBSCRIBER, value);
      });
    }
  }
};
</script>